document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-wrapper, sticky-header");
  if (!header) return;

  const menu = header.querySelector(".header__inline-menu");
  if (!menu) return;

  const detailsList = Array.from(menu.querySelectorAll("details"));
  if (!detailsList.length) return;

  let closeTimer = null;

  const closeAll = () => detailsList.forEach(d => d.removeAttribute("open"));

  const openOnly = (target) => {
    if (closeTimer) clearTimeout(closeTimer);
    detailsList.forEach(d => {
      if (d === target) d.setAttribute("open", "");
      else d.removeAttribute("open");
    });
  };

  const scheduleClose = () => {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      // Si el mouse sigue en el header o en algún dropdown, no cierres
      const hoveringHeader = header.matches(":hover");
      const hoveringMega = detailsList.some(d => {
        const mega = d.querySelector(".mega-menu");
        return mega && mega.matches(":hover");
      });

      if (!hoveringHeader && !hoveringMega) closeAll();
    }, 180);
  };

  // 1) Abrir SOLO el item que hovereás
  detailsList.forEach(d => {
    const summary = d.querySelector("summary");
    if (!summary) return;

    summary.addEventListener("mouseenter", () => openOnly(d));

    const mega = d.querySelector(".mega-menu");
    if (mega) {
      mega.addEventListener("mouseenter", () => openOnly(d));
      mega.addEventListener("mouseleave", scheduleClose);
    }
  });

  // 2) Cerrar con delay cuando salís del header
  header.addEventListener("mouseleave", scheduleClose);

  // 3) Si volvés a entrar al header, cancelamos el cierre
  header.addEventListener("mouseenter", () => {
    if (closeTimer) clearTimeout(closeTimer);
  });
});



